/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscodehint2Inputs */

const en_partnerscodehint2 = /** @type {(inputs: Partnerscodehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowercase letters, digits and dashes. Left empty, it is made from the name. It cannot be changed later.`)
};

const de_partnerscodehint2 = /** @type {(inputs: Partnerscodehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleinbuchstaben, Ziffern und Bindestriche. Leer gelassen, wird es aus dem Namen gebildet. Später lässt es sich nicht mehr ändern.`)
};

/**
* | output |
* | --- |
* | "Lowercase letters, digits and dashes. Left empty, it is made from the name. It cannot be changed later." |
*
* @param {Partnerscodehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscodehint2 = /** @type {((inputs?: Partnerscodehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscodehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscodehint2(inputs)
	return de_partnerscodehint2(inputs)
});
export { partnerscodehint2 as "partnersCodeHint" }